import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stripHtml',
    standalone: true
})
export class StripHtmlPipe implements PipeTransform {

    /**
     * Code taken from https://stackoverflow.com/questions/46271634/strip-html-in-angular-template-binding
     * @param value
     * @param args
     */
    transform(value: any, args?: any): any {
        if (!value) {
            return undefined;
        }

        return value.replace(/<.*?>/g, '');
    }

}
